/** Full-frame 36 × 24 mm sensor, rotated for portrait and cropped to the output aspect ratio. */
export function cameraVerticalFieldOfView(lens: number, width: number, height: number): number {
  if (!Number.isFinite(lens) || lens < 24 || lens > 800 || !Number.isFinite(width) || !Number.isFinite(height)
    || width <= 0 || height <= 0) throw new RangeError('Camera optics need a 24–800mm lens and positive frame dimensions.');
  const ratio = width / height;
  const sensorHeight = ratio >= 1 ? Math.min(24, 36 / ratio) : Math.min(36, 24 / ratio);
  return 2 * Math.atan(sensorHeight / (2 * lens)) * 180 / Math.PI;
}
